import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import { List as List$2 } from './List.styles.js';

var _excluded = ["type", "children"];
var List = function List(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'unordered' : _ref$type,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var listTag = 'ul';
  if (type !== 'unordered') {
    listTag = 'ol';
  }
  return /*#__PURE__*/React.createElement(List$2, _extends({
    className: "leshen-list leshen-list".concat(type),
    as: listTag
  }, props), children);
};
var List$1 = List;

export { List$1 as default };
//# sourceMappingURL=index.js.map
